import { useState, useContext, useRef, useEffect } from "react";
import { Box, Popover, Checkbox, Autocomplete, Radio, FormControl, FormControlLabel, RadioGroup, InputAdornment, OutlinedInput, Typography, Avatar, Grid, Chip, TextField, Tooltip, Select, MenuItem } from "@mui/material";
import TitleBar from "../../components/layout-components/TitleBar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import "./AddProject.scss";
import ColorPickerWithPalettes from "../../components/ColorPickerWithPalettes";
import { ReactComponent as DownArrow } from "../../assets/images/ralvie/dropDown.svg";
import { ReactComponent as ArrowUp } from "../../assets/images/ralvie/ArrowUp.svg";
import CustomizedDatePicker from "../../components/CustomizedDatePicker";
import { useTranslation } from "react-i18next";
import CustomAutoComplete from "../../components/CustomAutoComplete";
import CustomTextField from "../../components/DescriptionBox";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import { ReactComponent as CloseIconImg } from "../../assets/images/close-icon.svg";
import ProjectTagTextField from "./ProjectTagfield";
import AddMembersComponent from "./AddMemberlist";
import { ReactComponent as CancelIcon } from "../../assets/images/ralvie/Close.svg";
import Emojipicker from "../tags/Emojipicker";
import TagIcon from "../../assets/images/ralvie/tag-icon-inactive.svg";
import AppContext from "../../config/AppContext";
import CloseIcon from '@mui/icons-material/Close';

import {
    bindPopover,
    bindTrigger,
    usePopupState,
} from "material-ui-popup-state/hooks";
import CancelDialog from "./CancelDialog";
import CustomButton from "../../components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { getSubscriptionLimit } from "../../services/Subscription";
import { clientList, rolesList } from "../../services/MemberService";
import { createTag, getAllTags } from "../../services/TagService";
import { createProject } from "../../services/ProjectService";
import { toast } from "sonner";
import CommonUtil from "../../util/CommonUtils";
import { getCompanySetting } from "../../services/CompanySettingService";

export default function AddProject() {
    const randomColorCode = CommonUtil.getRandomColor();
    const { t, i18n } = useTranslation();
    const [projectName, setProjectName] = useState("");
    const [projectColor, setProjectColor] = useState(randomColorCode);
    const [randomColorData, setRandomColorData] = useState(randomColorCode);
    const [projectDescription, setProjectDescription] = useState("");
    const [objective, setObjective] = useState("");
    const [clientId, setClientId] = useState("");
    const [timelineStartDate, setTimelineStartDate] = useState(null);
    const [timelineEndDate, setTimelineEndDate] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [tagOptions, setTagOptions] = useState([]);
    const [isBillable, setIsBillable] = useState(false);
    const [billableType, setBillableType] = useState("Member default");
    const [budgetType, setBudgetType] = useState("time");
    const [cost, setCost] = useState("0");
    const [time, setTime] = useState("0");
    const [tagError, setTagError] = useState("");
    const [membersList, setMembersList] = useState({});
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const location = useLocation();
    const [timeError, setTimeError] = useState("");
    const fromView = location.state ? location.state?.fromView : null;
    const selectRef = useRef(null);
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [tagSearchValue, SetTagSearchValue] = useState("")

    const [isRecurring, setIsRecurring] = useState(false);
    const [tagIcon, setTagIcon] = useState();
    const fileInputRef = useRef(null);
    const [tagIconFile, setTagIconFile] = useState(null);
    const [error, setError] = useState(null);
    const [isSaveButtonDisable, setSaveButtonDisable] = useState(false);

    const { mode } = useContext(AppContext);

    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [selectedEmoji, setSelectedEmoji] = useState(null);
    const [expandedAccordion, setExpandedAccordion] = useState("basic");
    const [defaultBudgetType, setDefaultBudgetType] = useState("");

    const [state, setState] = useState({
        projectName: "",
        projectColor: "",
        projectDescription: "",
        objective: "",
        clientName: "",
        clientEmail: "",
        timelineStartDate: "",
        timelineEndDate: "",
        tags: [],
    });

    const [errors, setErrors] = useState({
        projectName: "",
        projectColor: "",
        projectDescription: "",
        objective: "",
        clientName: "",
        clientEmail: "",
        timelineStartDate: "",
        timelineEndDate: "",
        tags: "",
    });
    useEffect(() => {
        getSubscriptionLimit("PROJECT_COUNT").then((res) => {
            if (res.data.code === "RCI0000") {
                console.log(res.data.data);
                const { currValue, limit } = res.data.data;
                if (currValue >= limit) {
                    navigate("/page-not-found");
                }
            } else {
                navigate("/page-not-found");
            }
        });
        loadBudgetType();
    }, []);

    const loadBudgetType = () => {
        getCompanySetting()
            .then((res) => {
                if (res.data.code === "RCI0000") {
                    setDefaultBudgetType(res.data.data.preferences.budgetType)
                    setBudgetType(res.data.data.preferences.budgetType == "all" ? "time" : res.data.data.preferences.budgetType);
                }else {
                    setDefaultBudgetType("all");
                    setBudgetType("time");
                }
            });
    }

    const handleMembers = (data) => {
        setMembersList(data);
    };

    const handleCancelButton = () => {
        const isPayloadEmpty = !(
            projectName !== "" ||
            projectColor !== randomColorData ||
            state.projectDescription !== "" ||
            timelineStartDate !== null ||
            timelineEndDate !== null ||
            selectedTags?.length > 0 ||
            cost !== "0" ||
            time !== "0" ||
            clientId !== "" ||
            isBillable !== false ||
            membersList.length > 1 ||
            billableType !== "Member default" ||
            budgetType !== "time"
        );

        if (!isPayloadEmpty) {
            setIsCancelDialogOpen(true);
        } else {
            window.history.go(-1);
        }
    };

    const handleCloseCancelDialog = () => {
        setIsCancelDialogOpen(false);
    };

    const handleConfirmCancel = () => {
        setIsCancelDialogOpen(false);
        if (fromView === "list") {
            navigate("/projects-list");
        } else {
            navigate("/projects");
        }
    };

    const handleBudgetType = (e) => {
        const newBudgetType = e.target.value;
        setBudgetType(newBudgetType);
        if (newBudgetType === "time") {
            setCost("0");
        } else if (newBudgetType === "cost") {
            setTime("0");
        }
        setTimeError("");
    };

    const handleDescriptionChange = (e) => {
        setState((prevState) => ({
            ...prevState,
            projectDescription: e.target.value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            projectDescription: "",
        }));
    };

    useEffect(() => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = "auto";
            const { scrollHeight } = textAreaRef.current;
            const height = Math.max(40, Math.min(scrollHeight, 300));
            textAreaRef.current.style.height = `${height}px`;
        }
    }, [state.projectDescription]);

    const textAreaRef = useRef(null);

    const maxCharactersPerRow = 100;
    const baseWidth = 800;
    const maxWidth = 1100;

    const calculateWidth = () => {
        if (state.projectDescription.length <= maxCharactersPerRow) {
            return baseWidth + state.projectDescription.length * 2;
        }
        return maxWidth;
    };

    useEffect(() => {
        rolesList().then((res) => {
            if (res?.data?.code === "UASI0000") {
                const clientRole = res?.data?.data?.roles?.find(
                    (role) => role?.name === "Client"
                );
                if (clientRole) {
                    clientList({ roleId: clientRole?.id }).then((r) => {
                        if (r?.data?.code === "RCI0000") {
                            const updatedClients = r?.data?.data
                                ?.filter((user) => user?.status !== "ARCHIVED")
                                .map((user, index) => {
                                    return {
                                        id: user?.userId,
                                        name: user?.name,
                                    };
                                })
                                ?.sort((a, b) => a.name.localeCompare(b.name));
                            setClients((prevState) => [...prevState, ...updatedClients]);
                        }
                    });
                } else {
                    console.log("Client role not found");
                }
            }
        });
    }, []);

    const [isReloadTags, setIsReloadTags] = useState(false);
    useEffect(() => {
        getAllTags()
            .then((res) => {
                if (res?.data && res?.data?.data && res?.data?.data?.tags) {
                    const sortedTags = res?.data?.data?.tags
                        ?.map((tag) => ({
                            value: tag?.id,
                            label: tag?.name,
                            url: tag?.iconUrl,
                        }))
                        ?.sort((a, b) => a.label.localeCompare(b.label));
                    setTagOptions(sortedTags);
                } else {
                    setTagOptions([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching tag list:", error);
                setTagOptions([]);
            });
    }, [isReloadTags]);

    const validateFields = () => {
        let valid = true;
        const newErrors = { ...errors };

        let firstErrorAccordion = null;
        // Reset all error messages
        Object.keys(newErrors).forEach((key) => {
            newErrors[key] = "";
        });

        // Validation checks for each field
        if (!projectName.trim()) {
            newErrors.projectName = t("RAL0001");
            valid = false;
            firstErrorAccordion = "basic";
        } else if (projectName.length < 1) {
            newErrors.projectName = t("RAL0547");
            valid = false;
            firstErrorAccordion = "basic";
        } else if (projectName.length > 50) {
            newErrors.projectName = t("RAL0548");
            valid = false;
            firstErrorAccordion = "basic";
        }

        if (!projectColor.trim()) {
            newErrors.projectColor = t("RAL0549");
            valid = false;
            firstErrorAccordion = "basic";
        }

        if (projectDescription && projectDescription.length > 2000) {
            newErrors.projectDescription = t("RAL0550");
            valid = false;
            if (!firstErrorAccordion) firstErrorAccordion = "details";
        }

        if (!objective.trim()) {
            newErrors.objective = t("RAL0001");
            valid = false;
            if (!firstErrorAccordion) firstErrorAccordion = "details";
        }

        if (!timelineStartDate) {
            newErrors.timelineStartDate = t("RAL0551");
            valid = false;
            firstErrorAccordion = "basic";
        }

        if (!timelineEndDate && !isRecurring) {
            newErrors.timelineEndDate = t("RAL0552");
            valid = false;
            firstErrorAccordion = "basic";
        }

        if (
            timelineStartDate &&
            timelineEndDate &&
            timelineStartDate >= timelineEndDate && !isRecurring
        ) {
            newErrors.timelineStartDate = t("RAL0553");
            newErrors.timelineEndDate = t("RAL0554");
            valid = false;
            firstErrorAccordion = "basic";
        }
        if (!firstErrorAccordion) {
            if (!objective.trim()) {
                newErrors.objective = t("RAL0001");
                valid = false;
                firstErrorAccordion = "details";
            }

            if (projectDescription && projectDescription.length > 2000) {
                newErrors.projectDescription = t("RAL0550");
                valid = false;
                firstErrorAccordion = "details";
            }
        }

        if (!firstErrorAccordion && budgetType === "time") {
            if (time > 50000) {
                newErrors.timeBudget = t("RAL0745");
                setTimeError(t("RAL0745"));
                // setTimeout(() => setTimeError(""), 2500);
                valid = false;
                firstErrorAccordion = "budget";
            } else if (time < 1) {
                newErrors.timeBudget = t("RAL0774");
                setTimeError(t("RAL0774"));
                valid = false;
                firstErrorAccordion = "budget";
            }
        }

        // Clear errors for budget section fields
        newErrors.clientEmail = "";
        newErrors.timelineStartDateError = "";

        setErrors(newErrors);
        if (!valid && firstErrorAccordion) {
            setExpandedAccordion(firstErrorAccordion);
        }

        if (membersList?.length <= 0) {
            toast.error(t("RAL0303"));
            return;
        }

        return valid;
    };

    const handleCreateProject = () => {
        let members = membersList;
        if (membersList.length > 0) {
            members?.forEach((m) => {
                if (CommonUtil.isEmptyString(m.cost)) {
                    m.cost = 0;
                }
            });
        }
        // Validate fields before proceeding

        const tmpTags = [];
        selectedTags.map((item) => {
            tmpTags.push(item.value);
        });

        if (validateFields()) {
            const payload = {
                name: projectName.trim(),
                description: state.projectDescription.trim(),
                color: projectColor,
                startDate: timelineStartDate,
                endDate: isRecurring ? null : timelineEndDate,
                objective: objective,
                tags: tmpTags,
                clientId: clientId,
                isBillable: isBillable,
                members: members,
                billableType: billableType,
                budgetType: budgetType,
                timeBudget: time,
                costBudget: cost,
            };

            // Print the payload for debugging
            // console.log("Payload:", payload);

            // console.log("descrtopre:", payload.description);
            setSaveButtonDisable(true)
            // Attempt to create the project using the API
            createProject(payload)
                .then((res) => {
                    setSaveButtonDisable(false)
                    // Handle the response from the API
                    if (res.data.code === "RCI0033") {
                        // Success: Display message and redirect
                        toast.success(t("RAL0325"));
                        if (location.state?.backto == undefined) {
                            if (fromView === "list") {
                                navigate("/projects-list");
                            } else {
                                navigate("/projects");
                            }
                        } else {
                            navigate(location.state?.backto);
                        }
                        // Clear all errors on success
                        setErrors({});
                    } else {
                        // Update errors based on specific error codes
                        setErrors((prevErrors) => {
                            const newErrors = { ...prevErrors };

                            let errorAccordion = null;
                            // Handle project description errors
                            if (["RCE0135", "RCE0136"].includes(res.data.code)) {
                                newErrors.projectDescription = res.data.message;
                                errorAccordion = "details";
                            } else {
                                newErrors.projectDescription = ""; // Clear if error resolved
                            }

                            // Handle project color error
                            if (res.data.code === "RCE0137") {
                                newErrors.projectColor = res.data.message;
                                errorAccordion = "basic";
                            } else {
                                newErrors.projectColor = ""; // Clear if error resolved
                            }

                            // Handle project name errors
                            if (
                                ["RCE0130", "RCE0132", "RCE0133", "RCE0146"].includes(
                                    res.data.code
                                )
                            ) {
                                newErrors.projectName = res.data.message;
                                errorAccordion = "basic";
                            } else {
                                newErrors.projectName = ""; // Clear if error resolved
                            }

                            if (errorAccordion) {
                                setExpandedAccordion(errorAccordion);
                            }
                            return newErrors;
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error creating project:", error);
                    // Handle error response from API
                    // Update state to show an error message to the user
                    toast.error(t("RAL0326"));
                });
        }
    };

    const handleColorChange = (color) => {
        setProjectColor("#".concat(color.toHex()));
    };

    useEffect(() => {
        console.log("Language changed to:", i18n.language);
        setErrors({});
    }, [i18n.language]);

    const tagSelected = (event, value) => {
        if (value.length > 50) {
            setTagError(t("RAL0327"));
            setTimeout(() => {
                setTagError("");
            }, 10000);
            return;
        }
        setSelectedTags(value.map((option) => option.value));
        setTagError("");
    };

    const handleBillableTypeChange = (value) => {
        setBillableType(value ? value : "Common cost");
        // Clear error message for billable cost
        setErrors((prevErrors) => ({
            ...prevErrors,
            billableType: "",
        }));
    };

    const handleTimelineStartDate = (date) => {
        if (date === null || date === "" || (date && isNaN(date.valueOf()))) {
            setTimelineStartDate(null);
            setErrors((prevErrors) => ({
                ...prevErrors,
                timelineStartDate: t("RAL0551"),
            }));
        } else {
            setTimelineStartDate(date);
            setErrors((prevErrors) => ({
                ...prevErrors,
                timelineStartDate: "",
            }));
        }
    };

    const handleTimelineEndDate = (date) => {
        if (date === null || date === "" || (date && isNaN(date.valueOf()))) {
            setTimelineEndDate(null);
            setErrors((prevErrors) => ({
                ...prevErrors,
                timelineEndDate: t("RAL0552"),
            }));
        } else {
            setTimelineEndDate(date);
            setErrors((prevErrors) => ({
                ...prevErrors,
                timelineEndDate: "",
            }));
        }
    };

    const handleBudgetChange = (event) => {
        let value = event.target.value;

        if (budgetType === "time") {
            value = value.replace(/[^0-9]/g, "");
            if (value.length > 5) {
                value = value.substring(0, 5);
            }
            if (value && value > 50000) {
                setTimeError(t("RAL0745"));
            } else if (value && value < 1) {
                setTimeError(t("RAL0774"));
            } else {
                setTimeError("");
            }
            setTime(value);
        } else {
            value = value.replace(/[^0-9.]/g, "");
            const decimalParts = value.split(".");
            let integerPart = decimalParts[0];
            if (integerPart.length > 5) {
                integerPart = integerPart.substring(0, 5);
            }
            let decimalPart = decimalParts[1] || "";
            if (decimalPart.length > 2) {
                decimalPart = decimalPart.substring(0, 2);
            }
            value =
                decimalParts.length > 1 ? `${integerPart}.${decimalPart}` : integerPart;
            setCost(value);
        }
        event.target.value = value;
    };

    const [newTag, setNewTag] = useState({
        name: "",
        color: "",
        iconUrl: "",
    });

    const handleFile = (event) => {
        handleFileError("");

        const file = event.target.files[0];
        if (!file) {
            return;
        }

        if (!/\/(jpeg|jpg|png)$/i.test(file.type)) {
            handleFileError(t("RAL0059"));
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            handleFileError(t("RAL0060"));
            event.target.value = "";
            return;
        }

        try {
            setTagIcon(URL.createObjectURL(file));
            setTagIconFile(file);
            handleFileError("");
        } catch (error) {
            console.error("Error during file upload", error);
            handleFileError(t("RAL0061"));
        }
        event.target.value = "";
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleFileError = (message) => {
        setError(message);
    };
    const handleAddChange = (e) => {
        const value = e.target.value;
        setNewTag({ ...newTag, name: value });
        setError("");
    };
    const handleClose = (e) => {
        e.stopPropagation()
        setAnchorEl(null);
    };
    const handleEmojiSelect = (emojiObject) => {
        setTagIcon(null);
        setSelectedEmoji(emojiObject);
        EmojiPopupState.close();
        setShowEmojiPicker(false);
    };
    const EmojiPopupState = usePopupState({
        variant: "popover",
        popupId: "demo-popup-popover",
    });

    const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsRecurring(isChecked);
    if (isChecked) {
        setErrors(prevErrors => ({
            ...prevErrors,
            timelineEndDate: ""
        }));
    }
   };

    const handleAddTag = () => {
        const payload = {
            name: newTag.name,
            color: newTag.color,
            iconUrl: selectedEmoji
                ? selectedEmoji.imageUrl
                : "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='18' height='17.998' viewBox='0 0 18 17.998'%3e%3cpath id='Subtraction_258' data-name='Subtraction 258' d='M17638.271%2c9060.5a2.493%2c2.493%2c0%2c0%2c1-1.781-.737l-7.795-7.785a.679.679%2c0%2c0%2c1-.2-.474v-8.332a.672.672%2c0%2c0%2c1%2c.67-.67h8.336a.654.654%2c0%2c0%2c1%2c.469.192l7.713%2c7.721v.046l.078.077a2.519%2c2.519%2c0%2c0%2c1%2c0%2c3.558l-5.713%2c5.667A2.506%2c2.506%2c0%2c0%2c1%2c17638.271%2c9060.5Zm-8.434-16.663h0v7.395l7.594%2c7.583a1.186%2c1.186%2c0%2c0%2c0%2c1.668%2c0l5.721-5.716a1.154%2c1.154%2c0%2c0%2c0%2c.342-.825%2c1.192%2c1.192%2c0%2c0%2c0-.342-.843l-7.594-7.594Zm3.5%2c4.629a1.13%2c1.13%2c0%2c1%2c1%2c1.129-1.13A1.135%2c1.135%2c0%2c0%2c1%2c17633.338%2c9048.465Z' transform='translate(-17628.5 -9042.501)' fill='%23a7a7a7'/%3e%3c/svg%3e", // Assuming selectedEmoji has the imageUrl property
        };

        createTag(payload).then((res) => {
            if (res.data.code === "RCI0022") {
                toast.success(t("RAL0197"));
                const newTagObject = {
                    value: res.data.data.id,
                    label: newTag.name,
                    url: payload.iconUrl
                };
                setSelectedTags(prev => [...prev, newTagObject]);
                setState(prev => ({ ...prev, tags: [...prev.tags, newTagObject] }));

                setIsReloadTags(!isReloadTags);
                resetOnAdd();
            } else {
                toast.error(res.data.message);
            }
        });
    };

    const resetOnAdd = () => {
        setNewTag({
            name: "",
            color: "",
            iconUrl: "",
        });
        setSelectedEmoji(null);
        setTagIcon(null);
        setError("");
    };

    const handleTagChange = (id) => () => {
        const newTag = tagOptions.find(t => t.value === id);

        setSelectedTags(prev => {
            const isSelected = prev.some(
                (selectedTag) => selectedTag?.value === newTag?.value
            );

            if (isSelected) {
                let updatedList = prev.filter(
                    (selectedTag) => selectedTag?.value !== newTag?.value
                );
                selectRef.current = updatedList;
                return updatedList;
            } else {
                let updatedList = [
                    ...prev,
                    newTag,
                ];
                selectRef.current = updatedList;
                return updatedList;
            }
        });
    }

    return (
        <>
            <TitleBar
                id="header-text-add-project"
                title={t("RAL0324")}
                navBack={true}
                onBackClick={handleCancelButton}
            ></TitleBar>
            <div className="addnewproject">
                <Accordion className="accordion"
                    expanded={expandedAccordion === "basic"}
                    onChange={(_, isExpanded) =>
                        setExpandedAccordion(isExpanded ? "basic" : null)
                    }
                    square={false}
                    elevation={0}
                    sx={{
                        "&.MuiAccordion-root": {
                            "::before": {
                                content: "none",
                            },
                        },
                    }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <div className="accordion-text-column">
                            <span className="labeladdbasic">{t("RAL1016")}</span>
                            <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>{t("RAL1017")}</span>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <div className="projectfirlcolorpicker">
                                <div className="projecttextfield1">
                                    <CustomTextField
                                        required={true}
                                        id="text-create-projectname"
                                        name="ProjectName"
                                        label={t("RAL0289")}
                                        placeholder={t("RAL0290")}
                                        error={errors.projectName}
                                        helperText={errors.projectName}
                                        value={projectName}
                                        onChange={(e) => {
                                            setProjectName(e.target.value);
                                            if (e.target.value.trim() !== "") {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    projectName: "",
                                                }));
                                            }
                                        }}
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                    />
                                </div>
                                <div className="colorLabelproject">
                                    <label id="text-project-color" className={mode === "dark" ? "colorLabelproDark" : "colorLabelpro"}>
                                        {t("RAL0291")}
                                    </label>
                                    <div className="colorPickerproject" onClick={handleClick}>
                                        <Box
                                            sx={{
                                                backgroundColor: projectColor,
                                                width: "86px",
                                                height: "19px",
                                                borderRadius: "2px",
                                                ...(projectColor &&
                                                    projectColor.startsWith("#f") && {
                                                    border: "1px solid #E0E0E0",
                                                }),
                                                ...(projectColor &&
                                                    projectColor.startsWith("#00") && {
                                                    border: "1px solid #000000",
                                                }),
                                            }}
                                        ></Box>
                                        {anchorEl ? <ArrowUp className="arrowupanddown" /> : <DownArrow className="arrowupanddown" />}
                                        <Popover
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "right",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                            }}
                                            disableRestoreFocus
                                        // sx={{ zIndex: 1000 }}
                                        >
                                            <div>
                                                <ColorPickerWithPalettes
                                                    selectedColor={projectColor}
                                                    setSelectedColor={setProjectColor}
                                                    onClose={handleClose}
                                                />
                                            </div>
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                            <div className="datepicker-dimension">
                                <div className="datepicker-dimension11">
                                    <CustomizedDatePicker
                                        required={true}
                                        id="btn-date-project"
                                        name="btn-date-project"
                                        label={t("RAL0294")}
                                        placeholder={t("RAL1039")}
                                        value={timelineStartDate}
                                        error={Boolean(errors.timelineStartDate)}
                                        helperText={errors.timelineStartDate || ""}
                                        onChange={handleTimelineStartDate}
                                        maxDate={timelineEndDate || ""}
                                    />
                                </div>
                                <div className="datepicker-dimension11">
                                    <CustomizedDatePicker
                                        required={true}
                                        id="btn-date-project"
                                        name="btn-date-project"
                                        disabled={isRecurring}
                                        label={t("RAL0295")}
                                        placeholder={t("RAL1040")}
                                        value={timelineEndDate}
                                        onChange={handleTimelineEndDate}
                                        error={Boolean(errors.timelineEndDate)}
                                        helperText={errors.timelineEndDate || ""}
                                        // minDate={timelineStartDate || ""}
                                        minDate={new Date()}
                                    />
                                    <span className="checkmarkboxdesk">
                                        <Checkbox className="checkmarkboxdesk11"
                                            checked={isRecurring}
                                            onChange={handleCheckboxChange} />
                                        {t("RAL1018")}
                                    </span>

                                </div>
                            </div>
                            <div className="addprojectclient">
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <label id="project-text-client">{t("RAL0296")}</label>
                                </Box>
                                <CustomAutoComplete
                                    id="dropdown-project-create-client"
                                    options={clients || []}
                                    placeholder={t("RAL0655")}
                                    value={clientId}
                                    onChange={setClientId}
                                    handleClear={() => setClientId("")}
                                />
                            </div>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion className="accordion"
                    expanded={expandedAccordion === "details"}
                    onChange={(_, isExpanded) => {
                        const basicErrors = {
                            projectName: errors.projectName,
                            projectColor: errors.projectColor,
                            timelineStartDate: errors.timelineStartDate,
                            timelineEndDate: errors.timelineEndDate
                        };

                        const hasBasicErrors = Object.values(basicErrors).some(error => error);

                        if (isExpanded && hasBasicErrors) {
                            setExpandedAccordion("basic");
                            return;
                        }

                        setExpandedAccordion(isExpanded ? "details" : null);
                    }}

                    square="false"
                    elevation={0}
                    sx={{
                        "&.MuiAccordion-root": {
                            "::before": {
                                content: "none",
                            },
                        },
                    }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <div className="accordion-text-column">
                            <span className="labeladdbasic">{t("RAL1019")}</span>
                            <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>{t("RAL1020")}</span>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <div className="objectiveproject">
                                <CustomTextField
                                    required={true}
                                    id="text-project-objective"
                                    label={t("RAL1021")}
                                    placeholder={t("RAL1022")}
                                    error={errors.objective}
                                    helperText={errors.objective}
                                    value={objective}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setObjective(value);

                                        if (errors.objective && value.trim() !== "") {
                                            setErrors((prevErrors) => ({
                                                ...prevErrors,
                                                objective: "",
                                            }));
                                        }
                                    }}
                                    inputProps={{
                                        maxLength: 255,
                                    }}
                                />
                            </div>
                            <div className="project-description-wrapper">
                                <CustomTextField
                                    id="text-project-description"
                                    name="Description"
                                    label={t("RAL0292")}
                                    rows={1}
                                    placeholder={t("RAL0293")}
                                    error={errors.projectDescription}
                                    helperText={errors.projectDescription}
                                    value={state.projectDescription}
                                    inputRef={textAreaRef}
                                    multiline
                                    onChange={handleDescriptionChange}
                                    inputProps={{
                                        maxLength: 2000,
                                    }}
                                    className="project-description-field"
                                />
                                <div className="project-description-counter"> {state.projectDescription?.length}/2000</div>
                            </div>
                            <div className="addprojecttagss">
                                <Box>
                                    <label id="project-text-client">{t("RAL0191")}</label>
                                </Box>
                                <FormControl
                                    fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        ref={selectRef}
                                        open={isSelectOpen}
                                        displayEmpty
                                        onOpen={() => setIsSelectOpen(true)}
                                        onClose={(event) => {
                                            if (selectedTags?.length == 0) {
                                                setIsSelectOpen(false);
                                            }
                                        }}
                                        id="dropdown-clientfilter"
                                        value={selectedTags}
                                        onChange={(event) => {
                                            event.defaultPrevented();
                                            const value = event.target.value;
                                            setSelectedTags(typeof value === 'string' ? value.split(',') : value);
                                        }}
                                        renderValue={(selected) => {

                                            if (selected.length === 0) {
                                                return (
                                                    <Box sx={{ color: mode === "dark" ? "#f8f8f880" : "#24242480", }} >{t("RAL1036")} </Box>
                                                );
                                            }
                                            // const selectedTagObjects = tagOptions.filter(tag => selected.includes(tag));
                                            return (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "8px",
                                                        maxHeight: "80px",
                                                        overflowY: "auto",
                                                        alignItems: "flex-start"
                                                    }}
                                                >

                                                    {selected.map(tag => (
                                                        <Box
                                                            key={tag.value}
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                backgroundColor: mode === "dark" ? "#000" : "#fff",
                                                                borderRadius: "6px",
                                                                padding: "4px 8px",
                                                                fontSize: "14px",
                                                                maxWidth: "170px",
                                                                overflow: "hidden",
                                                                pointerEvents: 'auto',
                                                                '& > *': {
                                                                    pointerEvents: 'auto',
                                                                }
                                                            }}
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                            }}
                                                        >
                                                            <img
                                                                src={tag?.url ? tag?.url : TagIcon}
                                                                alt={tag?.label}
                                                                style={{ width: "16px", height: "16px", marginRight: "6px" }}
                                                            />
                                                            <Tooltip title={tag?.label}>
                                                                <span style={{
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    maxWidth: "90px"
                                                                }}>
                                                                    {tag?.label}
                                                                </span>
                                                            </Tooltip>
                                                            <CloseIcon
                                                                onMouseDown={(e) => {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedTags(prev => prev.filter(tags => tags.value !== tag.value));
                                                                    setState(prev => ({ ...prev, tags: prev.tags.filter(t => t.value !== tag.value) }))
                                                                }}
                                                                sx={{
                                                                    fontSize: "16px",
                                                                    marginLeft: "6px",
                                                                    cursor: "pointer",
                                                                    color: "#999",
                                                                    '&:hover': {
                                                                        color: "red",
                                                                    },
                                                                    pointerEvents: 'auto',
                                                                }}
                                                            />
                                                        </Box>
                                                    ))}
                                                </Box>
                                            );
                                        }}
                                        className="allClientsDropdown"
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    borderRadius: "5px",
                                                    maxHeight: "400px",
                                                },
                                            },
                                            disableAutoFocusItem: true,
                                            autoFocus: false,
                                        }}
                                        multiple
                                        sx={{
                                            borderRadius: "5px",
                                            background: mode === "light" ? "var(--color-42)" : "var(--color-47-50)",
                                            font: "normal normal normal 16px/20px Gotham",
                                            "& .MuiSelect-select": {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: "8px",
                                                alignItems: "flex-start",
                                                overflowY: "auto",
                                                maxHeight: "100px",
                                                color: mode === "light"
                                                    ? "var(--color-43) !important"
                                                    : "var(--color-33-80) !important",
                                            },
                                        }}
                                    >
                                        <Box sx={{ padding: "20px 20px 0 20px" }}>
                                            <TextField
                                                className={mode === "dark" ? "projectSelectMem1234Dark" : "projectSelectMem1234"}
                                                id="select-check-clientfilter"
                                                placeholder={t("RAL0192")}
                                                fullWidth
                                                size="small"
                                                value={tagSearchValue}
                                                autoComplete="off"
                                                onChange={(e) => SetTagSearchValue(e.target.value)}
                                                InputLabelProps={{ shrink: false }}
                                                InputProps={{
                                                    onClick: (e) => {
                                                        e.stopPropagation();
                                                    },
                                                    endAdornment: tagSearchValue && (
                                                        <CloseIcon
                                                            onClick={() => SetTagSearchValue("")}
                                                            className="timeerrorduimension11"
                                                        />
                                                    ),
                                                }}

                                                inputProps={{
                                                    maxLength: 20
                                                }}
                                            />
                                            <Box className="taglist-selected1">
                                                <Typography sx={{
                                                    color: mode === "light" ? "#242424" : "#f8f8f880",
                                                    fontFamily: "Gotham"
                                                }}>
                                                    {t("RAL1027")}
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Gotham",
                                                            color: mode === "light" ? "#1D0B77" : "auto",
                                                            cursor: "default"
                                                        }}
                                                    >
                                                        {selectedTags?.length ? selectedTags?.length : 0} {t("RAL0934")}
                                                    </Typography>
                                                    <Tooltip title={t("RAL0693")}>
                                                        <CloseIcon
                                                            className="timeerrorduimension11"
                                                            onClick={() => setSelectedTags([])}
                                                        />
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                            <div className={mode === "dark" ? "dividerbillingcarddark111" : "dividerbillingcard111"}></div>
                                        </Box>

                                        <Box sx={{
                                            maxHeight: 200,
                                            overflowY: "auto",
                                            scrollbarWidth: "thin",
                                            scrollbarColor: "var(--background-color-38) transparent",
                                            "&::-webkit-scrollbar": {
                                                width: "8px",
                                                backgroundColor: "transparent",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                borderRadius: "10px",
                                            },
                                        }}>
                                            {tagOptions &&
                                                (() => {
                                                    const filteredTags = tagOptions.filter(tag =>
                                                        tag.label?.toLowerCase().includes(tagSearchValue?.toLowerCase())
                                                    );
                                                    if (filteredTags.length === 0) {
                                                        return (
                                                            <MenuItem disabled className="menu-item-notags">
                                                                {t("RAL0522")}
                                                            </MenuItem>
                                                        );
                                                    }
                                                    return filteredTags.map((tag) => (
                                                        <MenuItem
                                                            id={`select-item-tagfilter-${tag.label}`}
                                                            key={tag.id}
                                                            value={tag.id}
                                                            onClick={handleTagChange(tag.value)}
                                                            // selected={selectedTags.includes(tag.id)}
                                                            selected={selectedTags.some(
                                                                (selectedTag) => selectedTag?.value === tag?.value
                                                            )}
                                                            className={mode === "dark" ? "handle-tafchangedark" : "handle-tafchange"}
                                                        >
                                                            <Checkbox
                                                                id={`select-item-check-tagfilter-${tag.label}`}
                                                                checked={selectedTags.some(
                                                                    (selectedTag) => selectedTag?.value === tag?.value
                                                                )}
                                                                className="select-item-check-tagfilter"
                                                            />
                                                            <img
                                                                id="project-image-tags"
                                                                src={tag?.url ? tag?.url : TagIcon}
                                                                alt={tag?.label}
                                                                style={{ width: "18px", height: "18px", margin: "0 10px" }}
                                                            />
                                                            {tag.label.length > 22 ? (
                                                                <Tooltip
                                                                    id={`select-item-tagfilter-${tag.label}`}
                                                                    title={tag.label}
                                                                    placement="top"
                                                                >
                                                                    <span id={`select-item-tagfilter-${tag.label}`}>
                                                                        {`${tag.label.substring(0, 22)}...`}
                                                                    </span>
                                                                </Tooltip>
                                                            ) : (
                                                                tag.label
                                                            )}
                                                        </MenuItem>
                                                    ));
                                                })()}
                                        </Box>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: "20px",
                                            width: "98%",
                                        }}>
                                            <CustomButton
                                                place="sp-cancel"
                                                variant="outlined"
                                                class="memberSaveButton"
                                                id="btn-cancel-member-list"
                                                name="btn-cancel-member-list"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsSelectOpen(false);
                                                    setSelectedTags(state.tags || [])
                                                    SetTagSearchValue("")
                                                    selectRef.current?.blur();
                                                }}
                                            >
                                                {t("RAL0177")}
                                            </CustomButton>
                                            <CustomButton
                                                variant="contained"
                                                class="memberCancelButton"
                                                id="btn-save-member-list"
                                                name="btn-save-member-list"
                                                onClick={(e) => {
                                                    SetTagSearchValue("")
                                                    e.stopPropagation();
                                                    setIsSelectOpen(false);
                                                    setState({ ...state, tags: selectedTags })
                                                    selectRef.current?.blur();
                                                }}
                                            >
                                                {t("RAL0677")}
                                            </CustomButton>
                                        </div>
                                    </Select>

                                </FormControl>
                            </div>
                            <div className="createtagsin">
                                <label id="text-project-add-tags">{t("RAL1023")}</label>
                                <div >
                                    <Box className="project-tags-add-wrapper" >
                                        <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            className={"new-tag " + (error ? "error-box" : "")}
                                            justifyContent={"center"}
                                            flexDirection={"row-reverse"}
                                        >
                                            <Box
                                                display={"flex"}
                                                flexGrow={1}
                                                className="tag-name"
                                                alignItems={"center"}
                                            >
                                                <Box item flexGrow={1}>
                                                    <ProjectTagTextField
                                                        id="textfield-tags-add"
                                                        label={t("RAL0194")}
                                                        error={!!error}
                                                        helperText={error}
                                                        value={newTag.name}
                                                        onChange={(e) => handleAddChange(e)}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleAddTag();
                                                            }
                                                        }}
                                                        onClick={handleAddTag}
                                                        onCancelClick={resetOnAdd}
                                                        inputProps={{
                                                            maxLength: 20,
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box className="tag-icon-pointer"  {...bindTrigger(EmojiPopupState)}>
                                                <Box item flexGrow={1} className="DropdownIcon">
                                                    <input
                                                        id="text-tags-file"
                                                        type="file"
                                                        ref={fileInputRef}
                                                        onChange={handleFile}
                                                        style={{ display: "none" }}
                                                        accept="image/png, image/jpeg, image/jpg"
                                                    />
                                                    {selectedEmoji || tagIcon ? (
                                                        <Avatar
                                                            id={"tags-emoji-avatar"}
                                                            variant="square"
                                                            src={selectedEmoji ? selectedEmoji.imageUrl : tagIcon}
                                                            className="emojidimensions"
                                                            {...bindTrigger(EmojiPopupState)}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={TagIcon}
                                                            alt="Tag icon"
                                                            className="emojidimensions"
                                                            {...bindTrigger(EmojiPopupState)}
                                                        />
                                                    )}
                                                </Box>
                                                <DownArrow
                                                    id={"tags-icon-arrowdown"}
                                                    {...bindTrigger(EmojiPopupState)}
                                                />
                                            </Box>
                                            <Popover
                                                {...bindPopover(EmojiPopupState)}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                }}
                                                disableRestoreFocus
                                                sx={{ zIndex: 1000 }}
                                            >
                                                <Emojipicker onEmojiSelect={handleEmojiSelect} />
                                            </Popover>
                                        </Box>
                                    </Box>
                                    {error && (
                                        <Box display={"flex"} alignItems={"center"} pt={0.5}>
                                            <Box item pr={0.5} mt={0.6}>
                                                <ErrorIcon />
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                <Typography id="tags-error-message" className="helper-text">
                                                    {error}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </div>
                            </div>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion className="accordion"
                    expanded={expandedAccordion === "budget"}
                    onChange={(_, isExpanded) => {
                        const basicErrors = {
                            projectName: errors.projectName,
                            projectColor: errors.projectColor,
                            timelineStartDate: errors.timelineStartDate,
                            timelineEndDate: errors.timelineEndDate
                        };

                        const detailsErrors = {
                            objective: errors.objective,
                            projectDescription: errors.projectDescription
                        };

                        const hasBasicErrors = Object.values(basicErrors).some(error => error);
                        const hasDetailsErrors = Object.values(detailsErrors).some(error => error);

                        if (hasBasicErrors) {
                            setExpandedAccordion("basic");
                            return;
                        }

                        if (hasDetailsErrors) {
                            setExpandedAccordion("details");
                            return;
                        }

                        const budgetErrors = {
                            timeBudget: errors.timeBudget
                        };

                        const hasBudgetErrors = Object.values(budgetErrors).some(error => error);

                        if (isExpanded && hasBudgetErrors) {
                            return;
                        }

                        setExpandedAccordion(isExpanded ? "budget" : null)
                    }}
                    square="false"
                    elevation={0}
                    sx={{
                        "&.MuiAccordion-root": {
                            "::before": {
                                content: "none",
                            },
                        },
                    }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <div className="accordion-text-column">
                            <span className="labeladdbasic">{t("RAL1024")}</span>
                            <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>{t("RAL1025")}</span>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <FormControl >
                                <RadioGroup
                                    id="btn-toggle-radio-project"
                                    sx={{
                                        flexDirection: "column",
                                        display: "flex",
                                        gap: "20px",
                                    }}
                                    value={budgetType}
                                    onChange={handleBudgetType}
                                >
                                    {["time", "all"].includes(defaultBudgetType)&&<Box className="formacontrol-align">
                                        <FormControlLabel
                                            id="btn-radio-time-project"
                                            className="btn-radio-time-project"
                                            name="btn-radio-time-project"
                                            value="time"
                                            control={
                                                <Radio
                                                    id="btn-radio-time-project"
                                                    sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                                />
                                            }
                                            label={t("RAL0280")}
                                        />
                                        <Box mt={1} >
                                            <label id="project-text-budget">{t("RAL1026")}</label>
                                            <div>
                                                <OutlinedInput
                                                    fullWidth
                                                    className="text-budget-project-cost"
                                                    name="text-budget-project-cost"
                                                    type="text"
                                                    placeholder={t("RAL0298")}
                                                    value={time}
                                                    onChange={handleBudgetChange}
                                                    endAdornment={
                                                        <InputAdornment position="end">hr</InputAdornment>
                                                    }
                                                    error={timeError}
                                                />
                                                <div className="error-container123">
                                                    {budgetType === "time" && timeError && (
                                                        <div className="timeerrorduimension">
                                                            <ErrorIcon />
                                                            {timeError}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </Box>
                                    </Box>}
                                    { ["cost","all"].includes(defaultBudgetType) && <Box className="formacontrol-align">
                                        <FormControlLabel
                                            id="btn-radio-cost-project"
                                            className="btn-radio-time-project1"
                                            name="btn-radio-cost-project"
                                            value="cost"
                                            control={
                                                <Radio
                                                    id="btn-radio-cost-project"
                                                    sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                                />
                                            }
                                            label={t("RAL0297")}
                                        />
                                        <Box mt={1} >
                                            <label id="project-text-budget">{t("RAL0298")}</label>
                                            <div>
                                                <OutlinedInput
                                                    fullWidth
                                                    className="text-budget-project-cost"
                                                    name="text-budget-project-cost"
                                                    type="text"
                                                    placeholder={t("RAL0298")}
                                                    value={cost}
                                                    onChange={handleBudgetChange}
                                                    endAdornment={
                                                        <InputAdornment position="end">$</InputAdornment>
                                                    }
                                                    error={timeError}
                                                />
                                            </div>
                                        </Box>
                                    </Box>}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <AddMembersComponent
                    className="accordion"
                    id="btn-toggle-exp-member"
                    selectedEmployee={handleMembers}
                    billableType={handleBillableTypeChange}
                    billableCostData={billableType}
                    expanded={expandedAccordion === "members"}
                    onChange={(_, isExpanded) =>
                        setExpandedAccordion(isExpanded ? "members" : null)
                    }
                />
            </div>
            <Grid
                container
                item
                xs={12}
                lg={12}
                spacing={3}
                alignItems={"end"}
                justifyContent={"flex-end"}
                mt={1}
                mb={2}
            >
                <Grid
                    sx={{
                        position: "sticky",
                        bottom: "1.5rem",
                    }}
                >
                    <CustomButton
                        place="sp-cancel"
                        variant="outlined"
                        class="memberButton"
                        id="btn-cancel-project"
                        name="btn-cancel-project"
                        onClick={handleCancelButton}
                    >
                        {t("RAL0177")}
                    </CustomButton>
                    <CustomButton
                        variant={"contained"}
                        class="memberButton"
                        id="btn-add-project"
                        name="btn-add-project"
                        onClick={handleCreateProject}
                        disabled={isSaveButtonDisable}
                    >
                        {t("RAL0170")}
                    </CustomButton>
                </Grid>
                <CancelDialog
                    open={isCancelDialogOpen}
                    onClose={handleCloseCancelDialog}
                    onConfirm={handleConfirmCancel}
                    header={t("RAL0382")}
                    message={t("RAL0378")}
                />
            </Grid>
        </>
    );
}
